import React from 'react';
import tw, { css } from 'twin.macro';

export const sliderProgress = [
  tw`absolute bg-neutral-moderate`,
  css`
    height: 6px;
    left: 0;
    right: 0;
    top: 5px;
    position: absolute;
  `,
];

function Track({
  source,
  target,
  getTrackProps,
  bgColor = '',
  className,
}: any) {
  const { onMouseDown, ...rest } = getTrackProps();
  return (
    <div
      className={className}
      css={sliderProgress}
      style={{
        marginTop: 35,
        left: `${source.percent}%`,
        width: `${target.percent - source.percent}%`,
        cursor: 'auto',
        backgroundColor: bgColor,
      }}
      {...rest}
    />
  );
}

export default Track;
